module.exports = __webpack_public_path__ + "media/images/Garmin_Connect-26e9cbae.png";